import { Outlet } from 'react-router-dom';

import { AppLayout } from '@spacefill/uikit/src/components/AppLayout/AppLayout';
import { Loader } from '@spacefill/uikit/src/components/Loader/Loader';

import { AnnouncementsBanner } from '../../layout/Annoucements/AnnouncementsBanner';
import { AppSidebar } from '../../layout/AppSidebar';
import { SpacefillTopbar } from '../../layout/Topbar';

const Profile = async () =>
    import('../../pages/profile/Edit').then((module) => ({
        Component: module.ProfilePage,
    }));
const CompanyProfileViewPage = async () =>
    import('../../pages/company-profile/CompanyProfileView').then((module) => ({
        Component: module.CompanyProfileView,
    }));
const NotificationRedirect = async () =>
    import('../../layout/Notifications/NotificationRedirect').then((module) => ({
        Component: module.NotificationRedirect,
    }));

const getUserRoutes = () => {
    return [
        {
            paths: ['/profile/', '/notifications-preferences/'],
            lazy: Profile,
        },
        {
            path: '/company/profile',
            lazy: CompanyProfileViewPage,
            redirectFrom: ['/company-profile'],
        },
        {
            path: '/company/coworkers',
            lazy: CompanyProfileViewPage,
        },
        {
            path: '/notifications-redirecting/',
            element: (
                <AppLayout
                    topbar={<SpacefillTopbar />}
                    leftNav={<AppSidebar />}
                    headerContent={<AnnouncementsBanner />}
                >
                    <Loader />
                    <Outlet />
                </AppLayout>
            ),
        },
        {
            path: '/notifications/',
            lazy: NotificationRedirect,
            redirectFrom: ['/notifications'],
        },
    ];
};

export { getUserRoutes };
